import { render, staticRenderFns } from "./ImsSettings.vue?vue&type=template&id=4fc16f26&"
import script from "./ImsSettings.vue?vue&type=script&lang=js&"
export * from "./ImsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports